import { useIsMounted } from '@ardoq/hooks';
import { forwardRef } from 'react';
import {
  DropdownMenuBodyWrapper,
  DropdownMenuHeaderWrapper,
  DropdownMenuWrapper,
} from '../atoms';
import { DropdownMenuProps, DropdownSize } from '../types';
import { DropdownMenuSection } from './DropdownMenuSection';

export const DropdownMenu = forwardRef<HTMLDivElement, DropdownMenuProps>(
  (
    {
      minDropdownSize,
      maxDropdownSize,
      children,
      headerContent,
      footerContent,
      ...props
    },
    ref
  ) => {
    const dropdownSize =
      !minDropdownSize && !maxDropdownSize
        ? props.dropdownSize || DropdownSize.S
        : DropdownSize.AUTO;
    const isVisible = useIsMounted();
    return (
      <DropdownMenuWrapper
        ref={ref}
        $dropdownSize={dropdownSize}
        $minDropdownSize={minDropdownSize}
        $maxDropdownSize={maxDropdownSize}
        $isVisible={isVisible || false}
      >
        {headerContent && (
          <DropdownMenuHeaderWrapper>{headerContent}</DropdownMenuHeaderWrapper>
        )}
        <DropdownMenuBodyWrapper>
          <DropdownMenuSection {...props} />
          {children}
        </DropdownMenuBodyWrapper>
        {footerContent && (
          <DropdownMenuHeaderWrapper>{footerContent}</DropdownMenuHeaderWrapper>
        )}
      </DropdownMenuWrapper>
    );
  }
);
DropdownMenu.displayName = 'DropdownMenu';
